<template>
    <span v-if="reasons.length">
        <BBadge
            :id="targetId"
            variant="light-warning"
            class="review-needs-attention-badge"
            :class="{ 'review-needs-attention-badge--compact': compact }"
            :role="compact ? null : 'button'"
            :tabindex="compact ? null : 0"
            :aria-label="label"
        >
            <FeatherIcon v-if="compact" :icon="icon" size="14" />
            <template v-else>{{ label }}</template>
        </BBadge>

        <BPopover
            :target="targetId"
            :triggers="compact ? 'hover' : 'hover focus'"
            placement="bottom"
            custom-class="review-needs-attention-badge__popover"
        >
            <template #title>{{ label }}</template>
            <ul class="mb-0 pl-1">
                <li v-for="reason in reasons" :key="reason.id">
                    {{ reason.message }}
                </li>
            </ul>
        </BPopover>
    </span>
</template>

<script>
import { BBadge, BPopover } from 'bootstrap-vue'

export default {
    name: 'ReviewNeedsAttentionBadge',
    components: {
        BBadge,
        BPopover,
    },
    props: {
        compact: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: 'AlertCircleIcon',
        },
        checks: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        targetId() {
            return `review-needs-attention-${this._uid}`
        },
        label() {
            return this.translate(
                'Component(ResearchReviewProcess):review-needs-attention',
                'Needs attention',
            )
        },
        reasons() {
            return this.checks
                .filter(check => check && check.status === 'needs_review' && check.reason)
                .map((check, index) => ({
                    id: check.id || `reason-${index}`,
                    message: this.translate(
                        check.reason.messageKey,
                        check.reason.fallbackMessage || check.id || '',
                        check.reason.params || {},
                    ),
                }))
                .filter(reason => reason.message)
        },
    },
    methods: {
        translate(key, fallback, params = {}) {
            const translation = key ? this.$t(key, params) : null

            return translation && translation !== key ? translation : fallback
        },
    },
}
</script>

<style scoped>
.review-needs-attention-badge {
    cursor: help;
    outline: none;
}

.review-needs-attention-badge--compact {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: .25rem;
    border-radius: 50%;
}
</style>
